import { HttpParams } from '@angular/common/http';
import { AfterViewInit, Component, Input, OnInit } from '@angular/core';
import { BolsaVacaciones } from '../../../core/models/bolsaVacaciones.model';
import { SolicitudBolsaVacaciones } from '../../../core/models/SolicitudBolsaVacaciones.model';
import { SolicitudBolsaVacacionesService } from '../../../core/services/solicitudesBolsaVacaciones.service';

@Component({
  selector: 'app-grid-solicitudes-bolsa-vacaciones',
  templateUrl: './grid-solicitudes-bolsa-vacaciones.component.html',
  styleUrls: ['./grid-solicitudes-bolsa-vacaciones.component.scss'],
  providers: [SolicitudBolsaVacacionesService]
})
export class GridSolicitudesBolsaVacacionesComponent implements AfterViewInit {

  constructor( protected _solicitudesBolsaVacacionesService: SolicitudBolsaVacacionesService,) { }

  solicitudes: SolicitudBolsaVacaciones[] = new Array<SolicitudBolsaVacaciones>();

  @Input() holidayExtraPay: BolsaVacaciones

  getSolicitudes() {

    if(this.holidayExtraPay){
      // console.log(this.holidayExtraPay);
      let params: HttpParams = new HttpParams().set("year", this.holidayExtraPay.Ejercicio.toString());

      this._solicitudesBolsaVacacionesService.getAll(this.holidayExtraPay.CodigoTrabajador, params).subscribe((res: SolicitudBolsaVacaciones[]) => {
      this.solicitudes = res;
    },
      error => {
        console.error(error);
      })
    }
  }

  ngAfterViewInit() {
    // console.log("ngAfterViewInit")
    this.getSolicitudes();
  }

}
